// extracted by mini-css-extract-plugin
export default {"card":"Forecast_card__UTaKh","box":"Forecast_box__goQXE"};